import { render } from "./ConfigPlaceholder.vue?vue&type=template&id=bd7a0096&ts=true"
import script from "./ConfigPlaceholder.vue?vue&type=script&lang=ts"
export * from "./ConfigPlaceholder.vue?vue&type=script&lang=ts"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__